module.exports = __webpack_public_path__ + "static/media/pasoapaso.1c5ce004.png";